<div id="closeMenu" >
    <dx-sortable filter=".dx-tab" [data]="pages" itemOrientation="horizontal"  *ngIf="pages?.length !== 0"
        dragDirection="horizontal" (onReorder)="onReorder($event)">
        <dx-tab-panel #tabs [dataSource]="pages" itemTitleTemplate="title" itemTemplate="item" [deferRendering]="false"
            [showNavButtons]="true" [repaintChangesOnly]="true" [selectedIndex]="selectedIndex"
            (onSelectionChanged)="selectionChanged($event)">
            <div *dxTemplate="let content of 'title'" (contextmenu)="onRightClick($event,content)">
                <span class="title">{{ content.name }}</span>
                <i class="dx-icon dx-icon-close" (click)="closeButtonHandler(content)"></i>
            </div> 
            <div *dxTemplate="let page of 'item'" style="position: relative;">
  
              <!-- Select flotante -->
              <div *ngIf="page.lisnk && page.lisnk.length > 0"
                   class="select-wrapper">
                <select class="custom-select" (change)="onValueMainform($event)">
                  <option value="" disabled selected>-- Seleccione una opción --</option>
                  <option *ngFor="let item of page.lisnk" [value]="item.MicroApplication_Id">
                    {{ item.Description }}
                  </option>
                </select>
              </div>
            
              <!-- Iframe debajo -->
              <div class="iframe-scroll-wrapper" [ngStyle]="getIframeScrollWrapperStyle()">
                <div [ngStyle]="getIframeScrollWrapperStyle()">
                  <iframe
                    #myIframe
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    [src]="page.url | safeUrl"
                    [title]="page.name"
                    style="z-index: 1; position: relative;">
                  </iframe>
                </div>
              </div>
            </div>
            
        </dx-tab-panel>
    </dx-sortable>
</div>


<div class="content-menu" id="content-menu">
    <ul class="d-flex flex-column" style="width:150px">
        <li class="btn btn-label btn-label-brand" (click)="reloadIframe(rightcontent)">Refrescar</li>
        <li class="btn btn-label btn-label-brand" (click)="closeButtonHandler(rightcontent)">Cerrar</li>
        <li class="btn btn-label btn-label-brand" (click)="closeTheOthersHandler(rightcontent)">Cerrar otras pestañas
        </li>
        <li class="btn btn-label btn-label-brand" (click)="closeAllHandler()">Cerrar todas</li>
    </ul>
</div>